/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, Divider, CircularProgress, Button } from '@material-ui/core'
import { Add } from '@material-ui/icons'


import Actions from '../../../../fluid/Actions/ActionFactory'

import Case from './components/Case'

import { v4 as uuidv4 } from 'uuid';
const clone = require("rfdc")();

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

let case_temp = {
    type: "screen",
    name: null,
    route: null,
    config: "/src/configs/screens/screens/queue-config.js",
    roles: ["ROLE_L1", "ROLE_ADMIN"],
    default_params : {
        icName : null,
        iuName : null,
        ticketID : null,
        col_name : null,
        columns : null,
        show_table : true,
        show_ticket : true,
        show_back : true,
        reference_field : null,
        show_app_bar : true,
        copy_to_parent : true,
        average_record_size : null,
        max_batch_threshold : null,
        filters : [],
        show_class : null,
        cta_config : [],
        screen_cta_config : []
    },
    show_in_sidebar : true,
    component : "queue"
}

class Cases extends Component {
    state = {
        loading : false,
        case_screens : [],
        editing_id : null,
        file_types : [],
        ic_object_list : []
    }

    componentDidMount () {
        Actions ('http_request', {
            url : "/sainapse/file_types",
            method : "get",
            data : {}
        }).then(res => {
            let file_types = res.data.result.map(file_type => file_type.type);
            this.setState({ ...this.state, file_types: file_types }, () => {
                Actions ('http_request', {
                    url : "/sainapse/information_channel",
                    method : "get",
                    data : {}
                }).then(res => {
                    let ic_list = res.data.result.map(ic => ic.name)
                    this.setState({...this.state, ic_loading : false, ic_list : ic_list, ic_object_list : res.data.result}, () => this.getCases())
                }).catch(err => {
                    this.setState({...this.state, ic_loading : false, ic_list : [], ic_object_list : null}, () => this.getCases())
                })
            })
        }).catch(err => {
            this.setState({ ...this.state, file_types: null }, () => {
                Actions ('http_request', {
                    url : "/sainapse/information_channel",
                    method : "get",
                    data : {}
                }).then(res => {
                    let ic_list = res.data.result.map(ic => ic.name)
                    this.setState({...this.state, ic_loading : false, ic_list : ic_list, ic_object_list : res.data.result}, () => this.getCases())
                }).catch(err => {
                    this.setState({...this.state, ic_loading : false, ic_list : [], ic_object_list : null}, () => this.getCases())
                })
            })
        })
    }


    getCases = () => {
        let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
        let case_screens = routes.drawer.find(section => section.id === 'cases').screens
        // case_screens.map(case_item => case_item.id = uuidv4())
        this.setState({...this.state, case_screens: case_screens})
    }

    updateCases = (case_screens) => {
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
        }).then(res => {
            let routes = res.data.result.config
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let cases = routes.drawer.find(section => section.id === 'cases')
            cases.screens = case_screens

            Actions('http_request', {
                url : "/sainapse/configuration/ui_routes",
                method : "put",
                data : {
                    config : routes
                }
            }).then(res => {
                let routes = res.data.result.config
                let case_screens = routes.drawer.find(section => section.id === 'cases').screens
                this.setState({...this.state, case_screens: case_screens, editing_id : null}, () => sessionStorage.setItem('ui_routes', JSON.stringify(res.data.result.config)))
            })
        })
    }

    updateCase = (case_config) => {
        console.log("Queue Config Update Case Called : ", case_config)
        Actions('http_request', {
            url : "/sainapse/configuration/ui_routes",
            method : "get",
            data : {}
        }).then(res => {
            let routes = res.data.result.config
            //let routes = JSON.parse(sessionStorage.getItem('ui_routes'))
            let cases = routes.drawer.find(section => section.id === 'cases')
            let case_screens = cases.screens
            let case_item_index = case_screens.findIndex(case_item => case_item.id === case_config.id)
            if (case_item_index !== -1) {
                case_screens.splice(case_item_index, 1, case_config)
            } else {
                case_screens.push(case_config)
            }
            this.updateCases(case_screens)
        })
    }

    deleteCase = (config) => {
        let new_state = clone(this.state)
        let case_index = new_state.case_screens.findIndex(screen => screen.id === config.id)
        new_state.case_screens.splice(case_index, 1)
        this.updateCases(new_state.case_screens)
    }

    addCase = () => {
        let new_case = clone(case_temp)
        new_case.id = uuidv4()
        let new_state = clone(this.state)
        new_state.case_screens.push(new_case)
        new_state.editing_id = new_case.id
        this.setState({...new_state})
    }

    editCase = (config) => {
        this.setState({...this.state, editing_id : config.id})
    }

    renderCaseScreens = () => {
        if (this.state.loading) {
            return (
                <div style = {{width : '100%', marginTop : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                    <CircularProgress variant = 'indeterminate'/>
                </div>
            )
        } else {
            let cases = this.state.case_screens.map(case_item => {
                return (
                    <Case
                        config = {case_item}
                        ic_object_list = {this.state.ic_object_list}
                        update = {(config) => this.updateCase(config)}
                        delete = {(config) => this.deleteCase(config)}
                        enable_edit = {(config) => this.editCase(config)}
                        editing_id = {this.state.editing_id}
                        file_types = {this.state.file_types}
                    />
                )
            })

            return cases
        }
    }

    renderAddScreen = () => {
        return (
            <Button
                style = {{marginTop : '10px'}}
                variant = 'contained'
                size = 'small'
                color = 'primary'
                startIcon = {<Add/>}
                onClick = {this.addCase}
            >
                Add Case Screen
            </Button>
        )
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', maxHeight : '100%', overflow : 'auto', padding : '10px'}}>
                    <Typography variant = 'subtitle2'>Case Screens</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    {this.renderCaseScreens()}
                    {this.renderAddScreen()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Cases);